import { useTranslation } from 'react-i18next';

import classes from './LanguageSwitcher.module.css';

const LanguageSwitcher = (props) => {
    const { i18n, t } = useTranslation();

    const languageSwitchHamdler = () => {
        const currentLanguage = i18n.resolvedLanguage;
        const changedLanguage = currentLanguage === 'en' ? 'ar' : 'en';
        i18n.changeLanguage(changedLanguage);
    }
    return (
        <div className={classes.LanguageSwitcher} onClick={languageSwitchHamdler}>
            <i className="fa-solid fa-globe"></i> <span className={classes.LanguageName}>{t('language')}</span>
        </div>
    );
}

export default LanguageSwitcher;